import React, { useRef, useState, useEffect, useContext } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import send from "../../Assets/Images/send.png";
import axios from "axios";
import {
  showToast,
  WEBSERVICE,
  checkCurrencyPairAccreditedStatus,
} from "../../CoreDataService";
import { useNavigate } from "react-router-dom";
import InfoPopUp from "../../Common/InfoPopUp";
import { DataContext } from ".";
import TelegramIcon from "@mui/icons-material/Telegram";
import InfoIcon from "@mui/icons-material/Info";
import AccreditationVerificationPopup from "../Accredited-Kyc/AccreditationVerificationPopup";
import TermsAgreementPopup from "../Accredited-Kyc/TermsAgreementPopup";
import { showErrorDialog } from "../../CoreDataService";

const title = "Market";
const description = `Users can Buy and Sell in the current market price. Enter "Buying
              Amount" and click on BUY to place a BUY Market order. Enter
              "Selling Amount" and click on SELL to place a SELL Market order.`;

const BuyAndSellOCO = ({
  selectedBuyingAssetBalance,
  selectedSellingAssetBalance,
  percentageValue,
  selectedOrderType,
  getUserTransaction,
  minBuySellAmount,
}) => {
  const { currencycode, basecurrency, ltp } = useContext(DataContext);
  const theme = localStorage.getItem("theme");
  const tradep = localStorage.getItem("priceprc") || 6;
  const navigate = useNavigate();
  const ltpdata = Number(ltp);
  const [show, setShow] = useState(false);
  const [progress, setProgress] = useState(0);
  const [progressOCO, setProgressOCO] = useState(0);
  const progressBarRef = useRef(null);
  const progressBarOCORef = useRef(null);
  const [sliderValue, setSliderValue] = useState(0);
  const [sliderValueOCO, setSliderValueOCO] = useState(0);
  const sliderRef = useRef(null);
  const sliderOCORef = useRef(null);
  const steps = [0, 25, 50, 75, 100];
  const [isLoading, setIsLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  const [stpLoader, setStpLoader] = useState(false);
  const handleClose = () => setShow(false);

  const [limitAmount, setLimitAmount] = useState("");
  const [limitPrice, setLimitPrice] = useState("");
  const [limitValue, setLimitValue] = useState("");
  const [error, setError] = useState(false);
  const [limitPriceSell, setLimitPriceSell] = useState("");
  const [limitAmountSell, setLimitAmountSell] = useState("");
  const [limitValueSell, setLimitValueSell] = useState("");
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  const [loading, setLoading] = useState(false);

  const [spotMyOfferData, setSpotMyOfferData] = useState();
  const [spotSpotLimitBuyData, setSpotSpotLimitBuyData] = useState();
  const [spotSpotLimitSellData, setSpotSpotLimitSellData] = useState();

  const [stopLossQuantitySell, setStopLossQuantitySell] = useState("");
  const [stopLossPriceSell, setStopLossPriceSell] = useState("");
  const [stopLossTotalSell, setStopLossTotalSell] = useState("");

  const [stopLossTriggerPrice, setStopLossTriggerPrice] = useState("");

  const [stopLossPrice, setStopLossPrice] = useState("");
  const [stopLossQuantity, setStopLossQuantity] = useState("");
  const [stopLossTotal, setStopLossTotal] = useState("");
  const [isInvalid, setIsInvalid] = useState(false);

  const [isPlaceOrderEnabled, setIsPlaceOrderEnabled] = useState(false);
  const [limitPriceForOco1, setLimitPriceForOco1] = useState("");
  const [limitAmountForOco1, setLimitAmountForOco1] = useState("");
  const [limittriggerForOco1, setLimitTriggerForOco1] = useState("");

  const [limitAmountForOco2, setLimitAmountForOco2] = useState("");
  const [limittriggerForOco2, setLimittriggerForOco2] = useState("");
  const [limitPriceForOco2, setLimitPriceForOco2] = useState("");
  const [isBuyDisabled, setIsBuyDisabled] = useState(true);
  const [stopLossError, setStopLossError] = useState(true);
  const [isPlaceOrderEnabledForSell, setIsPlaceOrderEnabledForSell] =
    useState(true);
  const [tradeData, setTradeData] = useState([]);
  const [marketOrderPrice, setMarketOrderPrice] = useState();
  const [showAccreditedPopup, setShowAccreditedPopup] = useState(false);
  const [showTermsPopup, setShowTermsPopup] = useState(false);
  const [termsLinks, setTermsLinks] = useState([]);
  const [pendingProceed, setPendingProceed] = useState(null);
  const [pendingTxnType, setPendingTxnType] = useState(null);

  const getAssetCode = (counter, base) => {
    try {
      const assets = JSON.parse(localStorage.getItem("spot_assets")) || [];

      const asset = assets.find(
        (item) =>
          counter.toUpperCase() === item.currencyCode.toUpperCase() &&
          base.toUpperCase() === item.baseCurrency.toUpperCase()
      );

      return asset ? asset.assetCode : "";
    } catch (error) {
      console.error("Error parsing spot_assets:", error);
      return "";
    }
  };

  /* Get base and counter ID of a pair */
  const getAssetId = (counter, base) => {
    try {
      const assets = JSON.parse(localStorage.getItem("spot_assets")) || [];

      const asset = assets.find(
        (item) =>
          counter.toUpperCase() === item.currencyCode.toUpperCase() &&
          base.toUpperCase() === item.baseCurrency.toUpperCase()
      );

      return asset
        ? { baseCurrencyId: asset.baseCurrencyId, currencyId: asset.currencyId }
        : {};
    } catch (error) {
      console.error("Error parsing spot_assets:", error);
      return {};
    }
  };
  const handleProgressChangeOCO = (event) => {
    if (!progressBarOCORef.current) return;

    const { left, width } = progressBarOCORef.current.getBoundingClientRect();
    const clickX = event.clientX - left;
    const rawProgress = (clickX / width) * 100;

    // Find the closest step value
    const closestStep = steps.reduce((prev, curr) =>
      Math.abs(curr - rawProgress) < Math.abs(prev - rawProgress) ? curr : prev
    );

    setProgressOCO(closestStep);
    handleSliderChangeOCO(closestStep);
  };
  const handleProgressChange = (event) => {
    if (!progressBarRef.current) return;

    const { left, width } = progressBarRef.current.getBoundingClientRect();
    const clickX = event.clientX - left;
    const rawProgress = (clickX / width) * 100;

    // Find the closest step value
    const closestStep = steps.reduce((prev, curr) =>
      Math.abs(curr - rawProgress) < Math.abs(prev - rawProgress) ? curr : prev
    );

    setProgress(closestStep);
    handleSliderChange(closestStep);
  };

  const handleSliderInteraction = (event) => {
    if (!sliderRef.current) return;

    const { left, width } = sliderRef.current.getBoundingClientRect();
    const clickX = event.clientX - left;
    const rawProgress = (clickX / width) * 100;

    // Find the closest step value
    const closestStep = steps.reduce((prev, curr) =>
      Math.abs(curr - rawProgress) < Math.abs(prev - rawProgress) ? curr : prev
    );

    setSliderValue(closestStep);
    getSellSliderValLimit(closestStep);
  };
  const handleSliderInteractionOCO = (event) => {
    if (!sliderOCORef.current) return;

    const { left, width } = sliderOCORef.current.getBoundingClientRect();
    const clickX = event.clientX - left;
    const rawProgress = (clickX / width) * 100;

    // Find the closest step value
    const closestStep = steps.reduce((prev, curr) =>
      Math.abs(curr - rawProgress) < Math.abs(prev - rawProgress) ? curr : prev
    );

    setSliderValueOCO(closestStep);
    getBuySliderValStopLimitOco(closestStep);
  };

  const validateLimit = () => {
    // const minAmount = 0.0001;
    // const minPrice = 0.00000001;
    // if (limitAmount <= minAmount || limitPrice <= minPrice) {
    //   setError(true);
    // } else {
    //   setError(false);
    // }
    if (limitAmount < minBuySellAmount?.minBuyQty) {
      showToast(
        "warning",
        `The amount must be at least ${minBuySellAmount?.minBuyQty}`
      );

      // document.getElementById("mbuy").disabled = true;
      return;
    }
  };

  const resetSlider = () => {
    setSliderValue(0);
    setProgress(0);
  };
  const calculateLimitTotalFromAmount = () => {
    const total = (limitAmount * limitPrice).toFixed(tradep);
    setLimitValue(isNaN(total) ? "" : total);
  };

  const calculateAmountFromLimitForLimit = (type) => {
    if (type === "buy") {
      const value = (parseFloat(limitAmount) * parseFloat(limitPrice)).toFixed(
        tradep
      );
      setLimitValue(isNaN(value) ? "" : value);
    } else if (type === "sell") {
      const valueSell = (
        parseFloat(limitAmountSell) * parseFloat(limitPriceSell)
      ).toFixed(tradep);
      setLimitValueSell(isNaN(valueSell) ? "" : valueSell);
    }
  };

  const calculateAmountFromTotalForLimit = async (type, e) => {
    let inputValue = e.target.value;

    try {
      const response = await axios.get(
        `https://stream.paybito.com/SocketStream/api/depth?symbol=${currencycode}${basecurrency}&limit=1`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      const data = response.data;
      let price, amount;

      if (type === "buy") {
        price = (parseFloat(data.ask[0].price) * 0.99).toFixed(8);
        amount = (parseFloat(inputValue) / parseFloat(price)).toFixed(8);
        setLimitValue(inputValue);
        setLimitPrice(price);
        setLimitAmount(isNaN(amount) ? "" : amount);
        setIsButtonDisabled(isNaN(amount) || parseFloat(amount) < 0.0001);
      } else {
        price = (parseFloat(data.bid[0].price) * 1.01).toFixed(8);
        amount = (parseFloat(inputValue) / parseFloat(price)).toFixed(8);
        setLimitValueSell(inputValue);
        setLimitPriceSell(price);
        setLimitAmountSell(isNaN(amount) ? "" : amount);
        setIsButtonDisabled(isNaN(amount) || parseFloat(amount) < 0.0001);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleSliderChange = async (sliderValue) => {
    setLoading(true);

    let newBalanceLimit = parseFloat(selectedSellingAssetBalance);
    const buyingCrypto = currencycode;
    const sellingCrypto = basecurrency;
    const accessToken = localStorage.getItem("access_token");

    try {
      const response = await axios.get(
        `https://stream.paybito.com/SocketStream/api/depth?symbol=${buyingCrypto}${sellingCrypto}&limit=1`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${accessToken}`,
          },
        }
      );
      const askPrice = parseFloat(response.data.ask[0].price);

      const calculatedLimitAmount = (
        (newBalanceLimit * (sliderValue / 100) -
          newBalanceLimit * (sliderValue / 100) * percentageValue) /
        askPrice
      ).toFixed(tradep);
      setLimitAmount(calculatedLimitAmount);
      let calP;
      if (sliderValue === 0) {
        setLimitPrice(0);
        calP = 0;
      } else {
        setLimitPrice((askPrice - askPrice * 0.01).toFixed(tradep));
        calP = askPrice - askPrice * 0.01;
      }
      setLimitValue((calculatedLimitAmount * calP).toFixed(tradep));
    } catch (error) {
      console.error("Error fetching market depth:", error);
    } finally {
      setLoading(false);
    }
  };

  const limitBuy = async () => {
    setIsLoading(true);

    if (parseFloat(limitAmount) <= 0.0001) {
      showToast("error", "Amount should be greater than 0.0001");
      setIsLoading(false);
      return;
    }
    const accreditationResult = await checkCurrencyPairAccreditedStatus(
      localStorage.getItem("userId"),
      currencycode?.toUpperCase(),
      basecurrency?.toUpperCase(),
      "BUY",
      limitAmount
    );

    if (!accreditationResult.accessAllowed) {
      setIsLoading(false);
      setShowAccreditedPopup(true);
      return;
    }

    const proceed = async () => {
      await doOcoLimitBuy();
    };

    if (accreditationResult.requiresTermsAgreement) {
      setIsLoading(false);
      setTermsLinks(accreditationResult.links || []);
      setPendingProceed(() => proceed);
      setPendingTxnType(1);
      setShowTermsPopup(true);
      return;
    }

    await proceed();
  };

  const doOcoLimitBuy = async () => {
    setIsLoading(true);

    if (limitPrice * limitAmount > 0) {
      if (limitAmount && limitPrice) {
        const tradeObj = {
          selling_asset_code: basecurrency.toUpperCase(),
          buying_asset_code: currencycode.toUpperCase(),
          amount: limitAmount,
          price: limitPrice,
          txn_type: "1",
          offerType:
            selectedOrderType === "FOK" || selectedOrderType === "IOC"
              ? "M"
              : "L",
          orderType:
            selectedOrderType !== "GTC" ? selectedOrderType : undefined,
          assetCode: getAssetCode(currencycode, basecurrency),
          baseCurrencyId: getAssetId(currencycode, basecurrency)
            ?.baseCurrencyId,
          currencyId: getAssetId(currencycode, basecurrency)?.currencyId,
          uuid: localStorage.getItem("uuid"),
        };

        try {
          const response = await fetch(
            `${WEBSERVICE}userTrade/TradeCreateOffer`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                authorization: `BEARER ${localStorage.getItem("access_token")}`,
              },
              body: JSON.stringify(tradeObj),
            }
          );

          const result = await response.json();
          setIsLoading(false);

          if (result.error.error_data !== 0) {
            if (result.error.error_data === 2) {
              showErrorDialog(result);
            } else {
              showToast("error", result.error.error_msg);
            }
          } else {
            showToast("success", result.error.error_msg);
            setLimitPrice(0);
            setLimitAmount(0);
            getUserTransaction();

            switch (localStorage.getItem("tradeNavHist")) {
              case "open":
                renderDataForMyOfferSpot();
                break;
              case "stop":
                renderDataForStopLimitSpot("buy");
                break;
              default:
                localStorage.setItem("isTimeToRenderSpotMyTrade", "true");
            }
          }
        } catch (error) {
          showToast("error", "Trade request failed");
          setIsLoading(false);
        }
      } else {
        showToast("warning", "Please provide proper buying details");
      }
    } else {
      showToast("warning", "Your offer is too small");
    }

    setLimitPrice(null);
    setLimitAmount(null);
    setIsLoading(false);
  };

  const renderDataForMyOfferSpot = async () => {
    try {
      const response = await fetch(
        `https://stream.paybito.com/StreamingApi/rest/getOfferByAccountIDRest?userID=${localStorage.getItem(
          "userId"
        )}&buyingAssetCode=${selectedBuyingAssetBalance.toLowerCase()}&sellingAssetCode=${selectedSellingAssetBalance.toLowerCase()}&pageNo=1&noOfItemsPerPage=10`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );
      const result = await response.json();
      setSpotMyOfferData(result.tradeListResult);
    } catch (error) {
      if (error.error?.error === "invalid_token") {
        //logout
      } else {
        showToast("error", "Could Not Connect To Server");
      }
    }
  };
  const logout = () => {
    localStorage.clear();
    navigate("/");
    window.location.reload();
  };

  const renderDataForStopLimitSpot = async (param) => {
    let transactionType = param === "buy" ? "1" : "2";
    const payload = {
      uuid: localStorage.getItem("uuid"),
      buying_asset_code:
        param === "buy"
          ? currencycode.toUpperCase()
          : basecurrency.toUpperCase(),
      selling_asset_code:
        param === "buy"
          ? basecurrency.toUpperCase()
          : currencycode.toUpperCase(),
      txn_type: transactionType,
    };

    try {
      const response = await fetch(
        `${WEBSERVICE}userTrade/GetStopLossBuySell`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
          body: JSON.stringify(payload),
        }
      );
      const result = await response.json();
      if (param === "buy") {
        setSpotSpotLimitBuyData(result.stopLossList);
      } else {
        setSpotSpotLimitSellData(result.stopLossList);
      }
    } catch (error) {
      if (error.error?.error === "invalid_token") {
        // data.//logout
        //logout
      } else {
        showToast("error", "Could Not Connect To Server");
      }
    }
  };

  const validateLimitSell = () => {
    if (limitAmountSell < minBuySellAmount?.minSellQty) {
      showToast(
        "warning",
        `The amount must be at least ${minBuySellAmount?.minSellQty}`
      );
      // document.getElementById("mbuy").disabled = true;
      return;
    }
  };

  const calculateLimitTotalFromAmountSell = () => {
    const total = (limitAmountSell * limitPriceSell).toFixed(tradep);
    setLimitValueSell(isNaN(total) ? "" : total);
  };

  const getSellSliderValLimit = async (newSliderValue) => {
    setStpLoader(true);

    // let sliderElement = document.getElementById("customRange4");
    // if (value === 4) {
    //   sliderElement.classList.add("changeBackgroundSlider");
    // } else {
    //   sliderElement.classList.remove("changeBackgroundSlider");
    // }

    let newSellBalanceLimit = parseFloat(selectedBuyingAssetBalance);
    let limitAmountSell = newSellBalanceLimit * (newSliderValue / 100);

    try {
      const response = await axios.get(
        `https://stream.paybito.com/SocketStream/api/depth?symbol=${currencycode}${basecurrency}&limit=1`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      let bidPrice = parseFloat(response.data.bid[0].price);
      let calculatedLimitPriceSell =
        newSliderValue === 0 ? 0 : (bidPrice + bidPrice * 0.01).toFixed(tradep);
      setLimitAmountSell(limitAmountSell);
      setLimitPriceSell(calculatedLimitPriceSell);
      setLimitValueSell(
        (limitAmountSell * calculatedLimitPriceSell).toFixed(tradep)
      );
      validateLimitSell();
    } catch (error) {
      console.error("Error fetching bid price", error);
    }

    setStpLoader(false);
  };

  const handleLimitSell = async () => {
    // if (!limitPriceSell || !limitAmountSell) {
    //   showToast("warning", "Please provide proper selling details");
    //   return;
    // }

    if (limitPriceSell * limitAmountSell < limitValueSell) {
      showToast("warning", "Your offer is too small");
      return;
    }
    if (parseFloat(limitAmountForOco1) <= 0.0001) {
      showToast("error", "Amount should be greater than 0.0001");
      return;
    }

    const accreditationResult = await checkCurrencyPairAccreditedStatus(
      localStorage.getItem("userId"),
      currencycode?.toUpperCase(),
      basecurrency?.toUpperCase(),
      "SELL",
      limitAmountSell
    );

    if (!accreditationResult.accessAllowed) {
      setIsLoading(false);
      setShowAccreditedPopup(true);
      return;
    }

    const proceed = async () => {
      await doOcoLimitSell();
    };

    if (accreditationResult.requiresTermsAgreement) {
      setIsLoading(false);
      setTermsLinks(accreditationResult.links || []);
      setPendingProceed(() => proceed);
      setPendingTxnType(2);
      setShowTermsPopup(true);
      return;
    }

    await proceed();
  };

  const doOcoLimitSell = async () => {
    setLoader(true);
    const inputObj = {
      selling_asset_code: currencycode.toUpperCase(),
      buying_asset_code: basecurrency.toUpperCase(),
      userId: localStorage.getItem("userId"),
      amount: limitAmountSell,
      price: limitPriceSell,
      txn_type: "2",
      offerType:
        selectedOrderType === "FOK" || selectedOrderType === "IOC" ? "M" : "L",
      assetCode: getAssetCode(currencycode, basecurrency),
      baseCurrencyId: getAssetId(currencycode, basecurrency)["baseCurrencyId"],
      currencyId: getAssetId(currencycode, basecurrency)["currencyId"],
      uuid: localStorage.getItem("uuid"),
      orderType: selectedOrderType !== "GTC" ? selectedOrderType : undefined,
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}userTrade/TradeCreateOffer`,
        inputObj,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      setLoader(false);
      if (response.data.error.error_data !== 0) {
        if (response.data.error.error_data === 2) {
          showErrorDialog(response.data);
        } else {
          showToast("error", response.data.error.error_msg);
        }
      } else {
        showToast("success", response.data.error.error_msg);
        localStorage.setItem("isTimeToRenderSpotMyTrade", "true");
        renderDataForMyOfferSpot();
        setLimitAmountSell(null);
        setLimitPriceSell(null);
        setLimitValueSell(null);
        getUserTransaction();
      }
    } catch (error) {
      setLoader(false);
      showToast("error", "Something went wrong");
    }
  };

  const validateStoplossAmountSell = (event) => {
    if (event.target.value < minBuySellAmount?.minSellQty) {
      showToast(
        "warning",
        `The amount must be at least ${minBuySellAmount?.minSellQty}`
      );
      // document.getElementById("mbuy").disabled = true;
      return;
    }
    const quantity = parseFloat(stopLossQuantitySell);
    // if (quantity <= 0.0001) {
    //   setError(true);
    //   setStopLossTotalSell("");
    //   return;
    // }
    const total = (quantity * parseFloat(stopLossPriceSell)).toFixed(tradep);
    setStopLossTotalSell(isNaN(total) ? "" : total);
    setError(false);
  };

  const validateStoplossTriggerPrice = (value) => {
    const numericValue = parseFloat(value);
    setStopLossTriggerPrice(numericValue);
    const isInvalid = numericValue <= 0.0001;
    setError(isInvalid);
  };

  const validateStoplossPrice = () => {
    if (parseFloat(stopLossPrice) <= 0.0001) {
      setIsInvalid(true);
      setStopLossTotal("");
      return true;
    } else {
      setIsInvalid(false);
      return false;
    }
  };

  const calculateAmountFromLimitForStopLoss = () => {
    if (stopLossPrice !== "" && stopLossQuantity !== "") {
      const total = (
        parseFloat(stopLossQuantity) * parseFloat(stopLossPrice)
      ).toFixed(tradep);
      setStopLossTotal(isNaN(total) ? "" : total);
    }
  };

  const handleSliderChangeOCO = (newSliderValue) => {
    setStpLoader(true);

    let ltp = parseFloat(ltpdata);
    let calculatedLimitPrice = (ltp - ltp * 0.02).toFixed(tradep);
    let calculatedLimitAmount =
      selectedBuyingAssetBalance * (newSliderValue / 100);
    let calculatedLimitTrigger = (ltp - ltp * 0.01).toFixed(tradep);
    setLimitPriceForOco1(calculatedLimitPrice);
    setLimitAmountForOco1(calculatedLimitAmount);
    setLimitTriggerForOco1(calculatedLimitTrigger);

    setIsPlaceOrderEnabled(parseFloat(calculatedLimitAmount) > 0.0001);

    setStpLoader(false);
  };

  const validateStoplossAmount = (event) => {
    if (event.target.value < minBuySellAmount?.minBuyQty) {
      showToast(
        "warning",
        `The amount must be at least ${minBuySellAmount?.minBuyQty}`
      );
      // document.getElementById("mbuy").disabled = true;
      return;
    }

    if (parseFloat(stopLossQuantity) <= 0.0001) {
      setIsBuyDisabled(true);
      setStopLossTotal("");
    } else {
      const total = (
        parseFloat(stopLossQuantity) * parseFloat(stopLossPrice)
      ).toFixed(tradep);
      setStopLossTotal(isNaN(total) ? "" : total);
      setIsBuyDisabled(false);
    }
  };

  const handleStopLimitAmount = (e) => {
    let inputValue = e.target.value;
    setStopLossQuantity(inputValue);

    const price = (parseFloat(ltpdata) + parseFloat(ltpdata) * 0.02).toFixed(
      tradep
    );
    const triggerPrice = (
      parseFloat(ltpdata) +
      parseFloat(ltpdata) * 0.01
    ).toFixed(tradep);
    setStopLossPrice(price);
    setStopLossTriggerPrice(triggerPrice);
    setStopLossTotal(
      (parseFloat(inputValue) * parseFloat(price)).toFixed(tradep)
    );
  };

  const getBuySliderValStopLimitOco = (newValue) => {
    setStpLoader(true);

    const newBuybalanceLimit = parseFloat(selectedSellingAssetBalance);

    const limitPriceForOco2 = (ltpdata + ltpdata * 0.02).toFixed(tradep);
    const limitAmountForOco2 = (
      (newBuybalanceLimit * (newValue / 100) -
        newBuybalanceLimit * (newValue / 100) * percentageValue) /
      parseFloat(limitPriceForOco2)
    ).toFixed(tradep);
    const limitTriggerForOco2 = (ltpdata + ltpdata * 0.01).toFixed(tradep);
    setLimitAmountForOco2(limitAmountForOco2);
    setLimittriggerForOco2(limitTriggerForOco2);
    setLimitPriceForOco2(limitPriceForOco2);
    setIsPlaceOrderEnabledForSell(parseFloat(limitAmountForOco2) > 0.0001);
    validateStoplossAmount();

    console.log("slide newBuybalance", newBuybalanceLimit);
    setStpLoader(false);
  };

  const renderDataForMyTradeSpot = async () => {
    try {
      const uuid = localStorage.getItem("uuid");
      const accessToken = localStorage.getItem("access_token");
      const buyingAsset = currencycode.toLowerCase(); // Replace with state/prop
      const sellingAsset = basecurrency.toLowerCase(); // Replace with state/prop

      const response = await axios.get(
        `https://stream.paybito.com/StreamingApi/rest/getTradeHistoryByIdRest?uuid=${uuid}&buyingAssetCode=${buyingAsset}&sellingAssetCode=${sellingAsset}&pageNo=1&noOfItemsPerPage=10`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${accessToken}`,
          },
        }
      );

      setTradeData(response.data.tradeListResult);
    } catch (error) {
      if (error.response?.data?.error === "invalid_token") {
        //logout
        // Handle logout logic here
      } else {
        showToast("error", "Could Not Connect To Server");
      }
    } finally {
      setLoading(false);
    }
  };

  const placeOrderForOcoBuy = async () => {
    if (ltpdata && limitPriceForOco1 && limittriggerForOco1) {
      const marketPrice = parseFloat(ltpdata);
      setMarketOrderPrice(marketPrice);

      if (
        marketPrice > parseFloat(limittriggerForOco1) &&
        marketPrice > parseFloat(limitPriceForOco1) &&
        parseFloat(limittriggerForOco1) > parseFloat(limitPriceForOco1)
      ) {
        const payload = {
          uuid: localStorage.getItem("uuid"),
          selling_asset_code: basecurrency.toUpperCase(),
          buying_asset_code: currencycode.toUpperCase(),
          amount: limitAmount,
          price: limitPrice,
          offerType: "L",
          txn_type: "1",
          assetCode: getAssetCode(
            localStorage.currencycode,
            localStorage.basecurrency
          ),
          quantity: limitAmountForOco1,
          stop_loss_price: limitPriceForOco1,
          trigger_price: limittriggerForOco1,
        };

        try {
          //   data.alert('Loading...', 'dark', 30000);
          //   document.getElementById('mBuyOrder').disabled = true;

          const response = await axios.post(
            `${WEBSERVICE}userTrade/createOCOOffer`,
            payload,
            {
              headers: {
                "Content-Type": "application/json",
                authorization: `BEARER ${localStorage.getItem("access_token")}`,
              },
            }
          );

          //   document.getElementById('mBuyOrder').disabled = false;
          const result = response.data;
          if (result.error.error_data !== 0) {
            if (result.error.error_data === 2) {
              showErrorDialog(result);
            } else {
              showToast("error", result.error.error_msg);
            }
          } else {
            showToast("success", result.error.error_msg);
            renderDataForMyTradeSpot();
            renderDataForMyOfferSpot();
            renderDataForStopLimitSpot("buy");
            setProgress(0);
            setProgressOCO(0);
            resetForm();
            getUserTransaction();
          }
        } catch (error) {
          console.error("OCO Buy Error:", error);
        }
      } else {
        showToast(
          "error",
          "*Market order price should be greater than stop price and limit price should be less than stop price"
        );
      }
    }
  };

  const resetForm = () => {
    setLimitAmount("");
    setLimitPrice("");
    setLimitValue("");
    setLimitPriceSell("");
    setLimitAmountSell("");
    setLimitValueSell("");
    setStopLossTriggerPrice("");
    setStopLossQuantity("");
    setLimitPriceForOco1("");
    setLimitAmountForOco1("");
    setLimitTriggerForOco1("");
    setLimitAmountForOco2("");
    setLimittriggerForOco2("");
    setLimitPriceForOco2("");
    setSliderValue(0);
    setSliderValueOCO(0);
    setProgress(0);
    setProgressOCO(0);
  };

  const placeOrderForOcoSell = async () => {
    if (ltpdata && limitPriceForOco2 && limittriggerForOco2) {
      const marketPrice = parseFloat(ltpdata);
      setMarketOrderPrice(marketPrice);

      if (
        marketPrice < parseFloat(limittriggerForOco2) &&
        marketPrice < parseFloat(limitPriceForOco2) &&
        parseFloat(limittriggerForOco2) < parseFloat(limitPriceForOco2)
      ) {
        const payload = {
          uuid: localStorage.getItem("uuid"),
          selling_asset_code: currencycode.toUpperCase(),
          buying_asset_code: basecurrency.toUpperCase(),
          amount: limitAmountSell,
          price: limitPriceSell,
          offerType: "L",
          txn_type: "2",
          assetCode: getAssetCode(currencycode, basecurrency),
          quantity: limitAmountForOco2,
          stop_loss_price: limitPriceForOco2,
          trigger_price: limittriggerForOco2,
        };

        try {
          //   data.alert('Loading...', 'dark', 30000);
          //   document.getElementById('mSellOrder').disabled = true;

          const response = await axios.post(
            `${WEBSERVICE}userTrade/createOCOOffer`,
            payload,
            {
              headers: {
                "Content-Type": "application/json",
                authorization: `BEARER ${localStorage.getItem("access_token")}`,
              },
            }
          );

          //   document.getElementById('mSellOrder').disabled = false;
          const result = response.data;
          if (result.error.error_data !== 0) {
            if (result.error.error_data === 2) {
              showErrorDialog(result);
            } else {
              showToast("error", result.error.error_msg);
            }
          } else {
            showToast("success", result.error.error_msg);
            setSliderValue(0);
            setSliderValueOCO(0);
            renderDataForMyTradeSpot();
            renderDataForMyOfferSpot();
            renderDataForStopLimitSpot("sell");
            resetForm();
            getUserTransaction();
          }
        } catch (error) {
          console.error("OCO Sell Error:", error);
        }
      } else {
        showToast(
          "error",
          "*Market order price should be less than stop price and limit price should be greater than stop price"
        );
      }
    }
  };

  return (
    <div>
      <div className="trade-wrap">
        {/* ── BUY Side ── */}
        <div className="trade-panel trade-panel-buy">
          <div className="trade-side-label buy-label">
            BUY {currencycode?.toUpperCase()}
          </div>
          <div className="trade-bal-row">
            <span>Available</span>
            <span>
              {selectedSellingAssetBalance} {basecurrency?.toUpperCase()}
            </span>
          </div>

          <div className="trade-oco-sub">
            {/* BUY – Limit sub-panel */}
            <div>
              <div className="trade-oco-sub-label">Limit Order</div>

              <div className="trade-input-group">
                <label>Amount</label>
                <div className="trade-input-box">
                  <input
                    type="number"
                    placeholder="0"
                    value={limitAmount}
                    onChange={(e) => {
                      const value = e.target.value;
                      const regex = new RegExp(`^\\d*\\.?\\d{0,${tradep}}$`);
                      if (regex.test(value)) {
                        setLimitAmount(value);
                      }
                    }}
                    onKeyUp={() => {
                      validateLimit();
                      setProgress(0);
                      calculateLimitTotalFromAmount();
                    }}
                  />
                  <span className="trade-unit">
                    {currencycode?.toUpperCase()}
                  </span>
                </div>
              </div>

              <div className="trade-input-group">
                <label>Price</label>
                <div className="trade-input-box">
                  <input
                    type="number"
                    value={limitPrice}
                    onChange={(e) => setLimitPrice(e.target.value)}
                    onKeyUp={() => {
                      validateLimit();
                      setProgress(0);
                      calculateAmountFromLimitForLimit("buy");
                    }}
                    placeholder="0"
                  />
                  <span className="trade-unit">
                    {basecurrency?.toUpperCase()}
                  </span>
                </div>
              </div>

              <div className="trade-input-group">
                <label>Total</label>
                <div className="trade-input-box">
                  <input
                    type="number"
                    value={limitValue}
                    onChange={(e) => {
                      calculateAmountFromTotalForLimit("buy", e);
                      setProgress(0);
                    }}
                    placeholder="0"
                    name="lval"
                  />
                  <span className="trade-unit">
                    {basecurrency?.toUpperCase()}
                  </span>
                </div>
              </div>

              <div className="trade-pct-row" ref={progressBarRef}>
                {[25, 50, 75, 100].map((pct) => (
                  <button
                    key={pct}
                    className={`trade-pct-btn${progress === pct ? " pct-active-buy" : ""
                      }`}
                    onClick={() => {
                      setProgress(pct);
                      handleSliderChange(pct);
                    }}
                  >
                    {pct}%
                  </button>
                ))}
              </div>
            </div>

            {/* BUY – Stop-Limit (OCO) sub-panel */}
            <div>
              <div className="trade-oco-sub-label">Stop-Limit (OCO)</div>

              <div className="trade-input-group">
                <label>Amount</label>
                <div className="trade-input-box">
                  <input
                    type="number"
                    placeholder="0"
                    value={limitAmountForOco1}
                    onChange={(e) => {
                      const value = e.target.value;
                      const regex = new RegExp(`^\\d*\\.?\\d{0,${tradep}}$`);
                      if (regex.test(value)) {
                        setLimitAmountForOco1(value);
                      }
                    }}
                    onKeyUp={(e) => {
                      validateStoplossAmountSell(e);
                      setProgressOCO(0);
                    }}
                  />
                  <span className="trade-unit">
                    {currencycode?.toUpperCase()}
                  </span>
                </div>
              </div>

              <div className="trade-input-group">
                <label>Stop</label>
                <div className="trade-input-box">
                  <input
                    type="number"
                    value={limittriggerForOco1}
                    onChange={(e) => setLimitTriggerForOco1(e.target.value)}
                    onKeyUp={(e) => {
                      validateStoplossTriggerPrice(e.target.value);
                      setProgressOCO(0);
                    }}
                    placeholder="0"
                  />
                  <span className="trade-unit">
                    {basecurrency?.toUpperCase()}
                  </span>
                </div>
              </div>

              <div className="trade-input-group">
                <label>Limit</label>
                <div className="trade-input-box">
                  <input
                    type="number"
                    value={limitPriceForOco1}
                    onChange={(e) => setLimitPriceForOco1(e.target.value)}
                    onKeyUp={() => {
                      validateStoplossPrice();
                      setProgressOCO(0);
                      calculateAmountFromLimitForStopLoss("sell");
                    }}
                    placeholder="0"
                  />
                  <span className="trade-unit">
                    {basecurrency?.toUpperCase()}
                  </span>
                </div>
              </div>

              <div className="trade-pct-row" ref={progressBarOCORef}>
                {[25, 50, 75, 100].map((pct) => (
                  <button
                    key={pct}
                    className={`trade-pct-btn${progressOCO === pct ? " pct-active-buy" : ""
                      }`}
                    onClick={() => {
                      setProgressOCO(pct);
                      handleSliderChangeOCO(pct);
                    }}
                  >
                    {pct}%
                  </button>
                ))}
              </div>
            </div>
          </div>

          <button
            className="trade-action-btn btn-buy"
            onClick={placeOrderForOcoBuy}
            disabled={
              limitAmount < minBuySellAmount?.minBuyQty ||
              limitAmountForOco1 < minBuySellAmount?.minSellQty
            }
          >
            Place Buy Order
          </button>
        </div>

        {/* ── SELL Side ── */}
        <div className="trade-panel">
          <div className="trade-side-label sell-label">
            SELL {currencycode?.toUpperCase()}
          </div>
          <div className="trade-bal-row">
            <span>Available</span>
            <span>
              {selectedBuyingAssetBalance} {currencycode?.toUpperCase()}
            </span>
          </div>

          <div className="trade-oco-sub">
            {/* SELL – Limit sub-panel */}
            <div>
              <div className="trade-oco-sub-label">Limit Order</div>

              <div className="trade-input-group">
                <label>Amount</label>
                <div className="trade-input-box">
                  <input
                    type="number"
                    placeholder="0"
                    value={limitAmountSell}
                    onChange={(e) => {
                      const value = e.target.value;
                      const regex = new RegExp(`^\\d*\\.?\\d{0,${tradep}}$`);
                      if (regex.test(value)) {
                        setLimitAmountSell(value);
                      }
                    }}
                    onKeyUp={() => {
                      validateLimitSell();
                      setSliderValue(0);
                      calculateLimitTotalFromAmountSell();
                    }}
                  />
                  <span className="trade-unit">
                    {currencycode?.toUpperCase()}
                  </span>
                </div>
              </div>

              <div className="trade-input-group">
                <label>Price</label>
                <div className="trade-input-box">
                  <input
                    type="number"
                    placeholder="0"
                    value={limitPriceSell}
                    onChange={(e) => setLimitPriceSell(e.target.value)}
                    onKeyUp={() => {
                      validateLimitSell();
                      setSliderValue(0);
                      calculateAmountFromLimitForLimit("sell");
                    }}
                  />
                  <span className="trade-unit">
                    {basecurrency?.toUpperCase()}
                  </span>
                </div>
              </div>

              <div className="trade-input-group">
                <label>Total</label>
                <div className="trade-input-box">
                  <input
                    type="number"
                    placeholder="0"
                    value={limitValueSell}
                    onChange={(e) => {
                      calculateAmountFromTotalForLimit("sell", e);
                      setSliderValue(0);
                    }}
                  />
                  <span className="trade-unit">
                    {basecurrency?.toUpperCase()}
                  </span>
                </div>
              </div>

              <div className="trade-pct-row" ref={sliderRef}>
                {[25, 50, 75, 100].map((pct) => (
                  <button
                    key={pct}
                    className={`trade-pct-btn${sliderValue === pct ? " pct-active-sell" : ""
                      }`}
                    onClick={() => {
                      setSliderValue(pct);
                      getSellSliderValLimit(pct);
                    }}
                  >
                    {pct}%
                  </button>
                ))}
              </div>
            </div>

            {/* SELL – Stop-Limit (OCO) sub-panel */}
            <div>
              <div className="trade-oco-sub-label">Stop-Limit (OCO)</div>

              <div className="trade-input-group">
                <label>Amount</label>
                <div className="trade-input-box">
                  <input
                    type="number"
                    placeholder="0"
                    value={limitAmountForOco2}
                    onChange={(e) => {
                      const value = e.target.value;
                      const regex = new RegExp(`^\\d*\\.?\\d{0,${tradep}}$`);
                      if (regex.test(value)) {
                        setLimitAmountForOco2(value);
                      }
                    }}
                    onKeyUp={(event) => {
                      validateStoplossAmount(event);
                      handleStopLimitAmount(event, "buy");
                      setSliderValueOCO(0);
                    }}
                  />
                  <span className="trade-unit">
                    {currencycode?.toUpperCase()}
                  </span>
                </div>
              </div>

              <div className="trade-input-group">
                <label>Stop</label>
                <div className="trade-input-box">
                  <input
                    type="number"
                    placeholder="0"
                    value={limittriggerForOco2}
                    onChange={(e) => setLimittriggerForOco2(e.target.value)}
                    onBlur={() => {
                      setSliderValueOCO(0);
                    }}
                  />
                  <span className="trade-unit">
                    {basecurrency?.toUpperCase()}
                  </span>
                </div>
              </div>

              <div className="trade-input-group">
                <label>Limit</label>
                <div className="trade-input-box">
                  <input
                    type="number"
                    placeholder="0"
                    value={limitPriceForOco2}
                    onChange={(e) => setLimitPriceForOco2(e.target.value)}
                    onKeyUp={() => {
                      validateStoplossPrice();
                      setSliderValueOCO(0);
                      calculateAmountFromLimitForStopLoss("buy");
                    }}
                  />
                  <span className="trade-unit">
                    {basecurrency?.toUpperCase()}
                  </span>
                </div>
              </div>

              <div className="trade-pct-row" ref={sliderOCORef}>
                {[25, 50, 75, 100].map((pct) => (
                  <button
                    key={pct}
                    className={`trade-pct-btn${sliderValueOCO === pct ? " pct-active-sell" : ""
                      }`}
                    onClick={() => {
                      setSliderValueOCO(pct);
                      getBuySliderValStopLimitOco(pct);
                    }}
                  >
                    {pct}%
                  </button>
                ))}
              </div>
            </div>
          </div>

          <button
            className="trade-action-btn btn-sell"
            onClick={placeOrderForOcoSell}
            disabled={
              limitAmountSell < minBuySellAmount?.minSellQty ||
              limitAmountForOco2 < minBuySellAmount?.minBuyQty
            }
          >
            Place Sell Order
          </button>
        </div>
      </div>

      <InfoPopUp
        open={show}
        onClose={handleClose}
        title={title}
        description={description}
      />
      <AccreditationVerificationPopup
        open={showAccreditedPopup}
        onClose={() => setShowAccreditedPopup(false)}
        theme={localStorage.getItem("theme")}
      />
      <TermsAgreementPopup
        open={showTermsPopup}
        onClose={() => {
          setShowTermsPopup(false);
          setPendingProceed(null);
        }}
        onProceed={() => {
          if (typeof pendingProceed === "function") {
            pendingProceed();
          }
          setPendingProceed(null);
        }}
        links={termsLinks}
        theme={localStorage.getItem("theme")}
        vestingCurrency={currencycode}
        txnType={pendingTxnType}
      />
    </div>
  );
};

export default BuyAndSellOCO;
